module.exports = __webpack_public_path__ + "static/media/google-logo.2d7c9127.png";